import * as actionTypes from '../constants/actionTypes';
export function setCommentCount(count) {
    return {
        type: actionTypes.SET_COMMENT_COUNT,
        count: count,
    };
}
export function showComments() {
    return {
        type: actionTypes.SHOW_COMMENTS,
    };
}
export function hideComments() {
    return {
        type: actionTypes.HIDE_COMMENTS,
    };
}
export function highlightComment(id) {
    return {
        type: actionTypes.HIGHLIGHT_COMMENT,
        id: id,
    };
}
export function unHighlightComment() {
    return {
        type: actionTypes.UNHIGHLIGHT_COMMENT,
    };
}
export function getLeaveCommentPopoverCookie() {
    return {
        type: actionTypes.GET_LEAVE_COMMENT_POPOVER_COOKIE,
    };
}
export function receiveLeaveCommentPopoverCookie(value) {
    return {
        type: actionTypes.RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE,
        value: value,
    };
}
export function setLeaveCommentPopoverCookie() {
    return {
        type: actionTypes.SET_LEAVE_COMMENT_POPOVER_COOKIE,
    };
}
export function showCommentNotification(notification) {
    return {
        type: actionTypes.SHOW_COMMENT_NOTIFICATION,
        notification: notification,
    };
}
export function hideCommentNotification() {
    return {
        type: actionTypes.HIDE_COMMENT_NOTIFICATION,
    };
}
